import loadable from '@wix/yoshi-flow-editor/loadable';

export const Reactions = loadable(
  () => import(/* webpackChunkName: "Reactions" */ './Reactions'),
  {
    resolveComponent: (component) => component.Reactions,
  },
);
